(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[70],{

/***/ 5986:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accessing-the-customer-portal",
      function () {
        return __webpack_require__(4513);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cb": function() { return /* binding */ FaqP; },
/* harmony export */   "nN": function() { return /* binding */ FaqSidebar; },
/* harmony export */   "xx": function() { return /* binding */ FaqH; },
/* harmony export */   "z$": function() { return /* binding */ FaqTemplate; }
/* harmony export */ });
/* unused harmony export FaqHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_DATA__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8362);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
// ** Next Imports




//Faq template
const FaqTemplate = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqHeader, {
                title: props.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "pad-top-60 pad-bot-60",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-md-9 col-lg-9 col-sm-9 col-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "faq-textual",
                                    children: props.children
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqSidebar, {})
                        ]
                    })
                })
            })
        ]
    });
//FAQ Header
const FaqHeader = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "bg-silver1 pad-top-40 pad-bot-40",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sec-head",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "no-margin",
                    children: props.title
                })
            })
        })
    });
//FAQ Sidebar
const FaqSidebar = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "col-md-3 col-lg-3 col-sm-3 col-12",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "sidebar",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "block-element m-b-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "list-3",
                    children: Object.keys(_helpers_DATA__WEBPACK_IMPORTED_MODULE_2__/* .FAQ_SIDEBAR_LINKS */ .Dm).map((lName, lKey)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: _helpers_DATA__WEBPACK_IMPORTED_MODULE_2__/* .FAQ_SIDEBAR_LINKS */ .Dm[lName],
                                children: lName
                            })
                        }, "faqsl-".concat(lKey)))
                })
            })
        })
    });
};
//Style Elements for FAQ
const FaqH = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
        className: "col-black",
        children: props.children
    });
const FaqP = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "col-grey1",
        children: props.children
    });


/***/ }),

/***/ 4513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ accessing_the_customer_portal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layouts/default/index.tsx + 7 modules
var layouts_default = __webpack_require__(6493);
// EXTERNAL MODULE: ./src/components/support/faqPages/index.tsx
var faqPages = __webpack_require__(8897);
;// CONCATENATED MODULE: ./public/images/cp1.png
/* harmony default export */ var cp1 = ({"src":"/_next/static/media/cp1.0a8420cd.png","height":274,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEWavuv////B3vKLr+KCseW0xd59ptzi4ux07aygAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAF0lEQVR4nGNgYGZjYQABRnZWJkZGRkYAAT8AIS3WffkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/images/cp2.png
/* harmony default export */ var cp2 = ({"src":"/_next/static/media/cp2.391166da.png","height":479,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAG1BMVEX9/v6QvN/x9PfM4PC71uujyOXR4/Lq7fB5rtmseA2zAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJUlEQVR4nBXIxw0AAAgDsSOh7T8x4meZkTQS2J1RkQDe2Hr0zwEG8QBeQwRigwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/pages/accessing-the-customer-portal/index.tsx
// ** Next imports


// ** File imports


// ** Img Imports


const AccessCustomerPortal = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts_default/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_default/* SEOHead */.R, {
                title: "Access Customer Portal - EIN"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(faqPages/* FaqTemplate */.z$, {
                title: "Accessing The Customer Portal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqH */.xx, {
                        children: "When can I access the Customer Portal?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqP */.Cb, {
                        children: "When your installation is complete you will be sent an email inviting you to access your Customer Portal. In the Customer Portal you can view your billing history, payment history, account information, and add a card to file for autopay."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqH */.xx, {
                        children: "Where do I access the Customer Portal?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqP */.Cb, {
                        children: "You can access the Customer Portal anytime by going to the EIN homepage and clicking on the Customer Portal link at the top of left of the page."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: cp1,
                        className: "img-fluid",
                        placeholder: "blur",
                        alt: "Customer Portal Menu"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqP */.Cb, {
                        children: "This will open the Customer Portal homepage, where you will find an option to log in to securely access your account information and history, as well as forms for quick access to the most common account requests."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: cp2,
                        className: "img-fluid",
                        placeholder: "blur",
                        alt: "Customer Portal Options"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(faqPages/* FaqH */.xx, {
                        children: "How do I reset or change my Customer Portal password?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(faqPages/* FaqP */.Cb, {
                        children: [
                            "If you need to reset your Customer Portal password please go to the login page at",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://my.easyinternetnow.com/portal/easyinternetnow/login",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "https://my.easyinternetnow.com/portal/easyinternetnow/login"
                            }),
                            " ",
                            "and click the ‘Forgot Password?’ text link below the login fields. You’ll need to provide the email you used when signing up with EIN (or the email on file if you’ve changed your email address in our system). You’ll receive an email with a link to set a new password."
                        ]
                    })
                ]
            })
        ]
    });
/* harmony default export */ var accessing_the_customer_portal = (AccessCustomerPortal);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,948,910,493,774,888,179], function() { return __webpack_exec__(5986); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);